import React from "react"
import Image from "gatsby-image"

import { Card, Header, Body, BodyContent } from "./style"

const Tag = ({
  tagName,
  shortDescription: { shortDescription },
  image: { fixed },
}) => {
  return (
    <Card>
      <Header>
        <Image fixed={fixed} />
      </Header>

      <Body>
        <BodyContent>
          <h1>{tagName}</h1>
          <p>{shortDescription}</p>
        </BodyContent>
      </Body>
    </Card>
  )
}

export default Tag
